import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CustomStep from 'workOrderComponents/close/CustomStep';
import { equipmentNeededForWorkOrderClosure } from '../../utils/accountEquipmentValidators';


class CloseOrderStatusStep extends React.Component {

    constructor(props) {
        super(props);
        this.handleStatusChange = this
            .handleStatusChange
            .bind(this);

        this.getStatusList = this
            .getStatusList
            .bind(this);

    }

    handleStatusChange(e, index, value) {
        e.preventDefault();
        const { workOrderActions, orderId, equipmentDetails, serviceTypeId, customerDetails } = this.props;
        const allEquipmentNeeded = customerDetails && customerDetails.get('signalAccessCode') === 'X';
        const skipValidation = customerDetails && customerDetails.get('customerSegmentation') === 'WHOLESALE';
        const equipmentValidation = equipmentNeededForWorkOrderClosure(equipmentDetails, serviceTypeId, allEquipmentNeeded, skipValidation);

        if (!equipmentValidation.isValid && value === "Complete") {
            alert(equipmentValidation.message);
            return;
        }
        workOrderActions.closeOrderStatusSet(value, orderId);

    }

    getStatusList() {
        const { serviceTypeId } = this.props;

        //PM Tickets can be cancelled
        if (serviceTypeId === 'SR-07') {
            return [
                {
                    value: 'Complete',
                    label: 'Complete'
                }, {
                    value: 'Cancel',
                    label: 'Cancel'
                }
            ];
        }

        return [
            {
                value: 'Complete',
                label: 'Complete'
            }, {
                value: 'NoAccess',
                label: 'No Access'
            }
        ];
    }

    getStatusItem(key) {
        let result = '';
        this
            .getStatusList()
            .forEach((item) => {

                if (item.value === key) {
                    result = ` - ${item.label}`;
                }
            });

        return result;
    }

    render() {
        const { orderCloseDetails, stepConfig, orderId, workOrderActions, disabled } = this.props;

        const currentStatus = orderCloseDetails.getIn(['closeOrderRequest', 'orderStatus']);
        const stepValidation = orderCloseDetails.getIn(['stepValidation']);
        const activeStep = orderCloseDetails.get('currentStep');

        const menuItems = this
            .getStatusList()
            .map((item, index) => {
                return (<MenuItem
                    key={`status_item_${index}`}
                    value={item.value}
                    primaryText={item.label} />);
            });

        return (

            <CustomStep
                onStepClick={workOrderActions.setCloseStep}
                label={`Order Status ${this.getStatusItem(currentStatus)}`}
                stepConfig={stepConfig}
                stepConfigKey="orderStatusStepConfig"
                orderCloseDetails={orderCloseDetails}
                activeStep={activeStep}
                orderId={orderId}
                stepValidation={stepValidation}
                stepKey="orderStatus">
                <SelectField
                    floatingLabelText="Select Order Status"
                    value={currentStatus}
                    disabled={disabled}
                    onChange={this.handleStatusChange}>

                    {menuItems}

                </SelectField>
            </CustomStep>

        );

    }
}

CloseOrderStatusStep.propTypes = {
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    stepConfig: PropTypes.object,
    disabled: PropTypes.bool,
    serviceTypeId: PropTypes.string
};

export default CloseOrderStatusStep;


// WEBPACK FOOTER //
// ./src/components/order-status/CloseOrderStatusStep.js